import React from 'react';

export default React.memo(function Badge({ icon, label, children, className = '' }) {
  return (
    <div className={`w-full flex items-center justify-center flex-col gap-2 rounded-lg overflow-hidden ${className}`}>
      {icon}
      <label>{label}</label>
        {children}
    </div>
  );
})
